module.exports = "//a.spikex.com/sigma/frontend-ssr-web-index/_next/static/images/phone-9496b4791b4019218d06415704cfadc3.svg";